import React, { type JSX } from 'react';
import LabelFilterContext from './LabelFilterContext';
import useLabelFilterContext from './useLabelFilterContext';
import { LabelFilter } from 'pages/Zones/types';

export type TLabelFilterProvider = {
  moduleName: string | null;
  pageSize: number | null;
  labelFilters: LabelFilter[] | null;
  children: JSX.Element[] | JSX.Element | undefined;
};

const LabelFilterProvider = ({ moduleName, labelFilters, pageSize, children }: TLabelFilterProvider) => {
  const value = useLabelFilterContext(moduleName, labelFilters ? labelFilters.slice(0) : [], pageSize);
  return <LabelFilterContext.Provider value={value}>{children}</LabelFilterContext.Provider>;
};

export default LabelFilterProvider;
